import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import routes from "./routes";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (
    process.env.NODE_ENV === "production" &&
    to.matched.some(record => record.meta.isAuth)
  ) {
    if (!store.getters["auth/isSignIn"]) {
      next({ name: "home" });
    } else {
      next();
    }
  } else {
    next(); // 确保一定要调用 next()
  }
});

export default router;
